import React from 'react';

import '../global.css';

export default () => (
	<div>
		Redirecting to Homepage, from MN Made Edina South Dasher...
	</div>
);